"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Tag = _interopRequireWildcard(require("../Tag"));
var _ListItem = _interopRequireWildcard(require("../ListItem"));
var _Icon = _interopRequireWildcard(require("../Icon"));
var _List = _interopRequireDefault(require("../List"));
var Styled = _interopRequireWildcard(require("./style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var TagsInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a;
  var disabled = props.disabled,
    tags = props.tags,
    createable = props.createable,
    _b = props.withList,
    withList = _b === void 0 ? true : _b,
    _c = props.filterNewTagsFromList,
    filterNewTagsFromList = _c === void 0 ? true : _c,
    showListOnInput = props.showListOnInput,
    onAdd = props.onAdd,
    onRemove = props.onRemove,
    onChange = props.onChange,
    onCreate = props.onCreate,
    onClick = props.onClick,
    DOMProps = __rest(props, ["disabled", "tags", "createable", "withList", "filterNewTagsFromList", "showListOnInput", "onAdd", "onRemove", "onChange", "onCreate", "onClick"]);
  var tagsRef = (0, _react.useRef)(tags);
  var listRef = (0, _react.useRef)(null);
  var previousShowPopoverState = (0, _react.useRef)(false);
  var _d = (0, _react.useState)(null),
    wrapperRef = _d[0],
    setWrapperRef = _d[1];
  var _e = (0, _react.useState)(null),
    inputRef = _e[0],
    setInputRef = _e[1];
  var _f = (0, _react.useState)(false),
    showPopover = _f[0],
    setShowPopover = _f[1];
  var _g = (0, _react.useState)(''),
    inputValue = _g[0],
    setInputValue = _g[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return wrapperRef;
  }, [wrapperRef]);
  (0, _react.useEffect)(function () {
    tagsRef.current = tags;
  }, [tags]);
  (0, _react.useEffect)(function () {
    if (showPopover && inputRef) {
      inputRef.focus();
    }
    if (!showPopover) {
      setInputValue('');
    }
  }, [showPopover, inputRef, wrapperRef]);
  (0, _react.useEffect)(function () {
    if (!showPopover && previousShowPopoverState.current) {
      wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.focus();
    }
  }, [showPopover, wrapperRef]);
  (0, _react.useEffect)(function () {
    previousShowPopoverState.current = showPopover;
  }, [showPopover]);
  var togglePopover = (0, _react.useCallback)(function () {
    setShowPopover(function (current) {
      return !current;
    });
  }, []);
  var handleOnWrapperClick = (0, _react.useCallback)(function (event) {
    if (!disabled) {
      if (!showPopover) {
        setShowPopover(true);
      }
      if (typeof onClick === 'function') {
        onClick(event);
      }
    }
  }, [disabled, showPopover, onClick]);
  var handleCreateNewTag = (0, _react.useCallback)(function (value) {
    if (createable && value.length && typeof onCreate === 'function') {
      onCreate(value);
    }
  }, [createable, onCreate]);
  var handleOnWrapperKeyDown = (0, _react.useCallback)(function (event) {
    switch (event.code) {
      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowRight':
      case 'ArrowLeft':
        {
          event.stopPropagation();
          event.preventDefault();
          break;
        }
      case 'Enter':
        {
          if (!showPopover) {
            setShowPopover(true);
          }
          break;
        }
      case 'Escape':
        {
          setShowPopover(false);
          break;
        }
    }
  }, [showPopover]);
  var pipeKeyDownToList = (0, _react.useCallback)(function (event) {
    if (listRef.current) {
      listRef.current.setFocus(true);
      var customEvent = new KeyboardEvent('keydown', event);
      listRef.current.dispatchEvent(customEvent);
    }
  }, []);
  var handleOnInputValueChange = (0, _react.useCallback)(function (value) {
    setInputValue(value);
  }, []);
  var handleOnInputKeyDown = (0, _react.useCallback)(function (event) {
    // event.stopPropagation()
    var _a;
    switch (event.code) {
      case 'Escape':
        {
          setShowPopover(false);
          break;
        }
      case 'ArrowUp':
      case 'ArrowDown':
        {
          event.preventDefault();
          pipeKeyDownToList(event);
          break;
        }
      case 'Enter':
        {
          if ((_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.isFocused) {
            event.preventDefault();
            pipeKeyDownToList(event);
          } else {
            setInputValue('');
            handleCreateNewTag(event.target.value);
          }
          break;
        }
      default:
        if (listRef.current) {
          listRef.current.setFocus(false);
        }
    }
  }, [pipeKeyDownToList, handleCreateNewTag]);
  var handleOnChange = (0, _react.useCallback)(function (tag) {
    var tagItems = tagsRef.current.map(function (item) {
      if (item.id === tag.id) {
        return tag;
      } else {
        return item;
      }
    });
    onChange === null || onChange === void 0 ? void 0 : onChange(tagItems);
  }, [onChange]);
  var handleOnRemove = (0, _react.useCallback)(function (selectedTag) {
    var tagItem = __assign(__assign({}, selectedTag), {
      selected: false
    });
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(tagItem);
    handleOnChange(tagItem);
  }, [onRemove, handleOnChange]);
  var handleOnSelect = (0, _react.useCallback)(function (selectedTag) {
    setInputValue('');
    if (selectedTag.selected) {
      handleOnRemove(selectedTag);
    } else {
      var tagItem = __assign(__assign({}, selectedTag), {
        selected: true
      });
      onAdd === null || onAdd === void 0 ? void 0 : onAdd(tagItem);
      handleOnChange(tagItem);
    }
    inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
  }, [handleOnRemove, onAdd, handleOnChange, inputRef]);
  var handleOnTagRemove = (0, _react.useCallback)(function (selectedTag) {
    return function (event) {
      event.stopPropagation();
      handleOnRemove(selectedTag);
      inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
    };
  }, [handleOnRemove, inputRef]);
  var hasTags = Array.isArray(tags) && tags.length ? true : false;
  var hasSelectedTags = hasTags && tags.filter(function (i) {
    return i.selected;
  }).length ? true : false;
  var selectedTags = (0, _jsxRuntime.jsx)(Styled.TagsWrapper, __assign({
    "$asInput": !showPopover,
    "$hasSelectedTags": hasSelectedTags
  }, {
    children: (0, _jsxRuntime.jsx)(Styled.TagsElements, {
      children: hasTags ? tags.map(function (tag) {
        if (tag.selected) {
          return (0, _jsxRuntime.jsx)(_Tag.default, {
            disabled: disabled,
            label: tag.label,
            size: _Tag.TagSizes.Small,
            iconProps: {
              tabIndex: showPopover ? 0 : -1
            },
            onRemove: handleOnTagRemove(tag)
          }, tag.id);
        } else {
          return null;
        }
      }) : null
    })
  }));
  return (0, _jsxRuntime.jsxs)(Styled.Wrapper, __assign({
    ref: setWrapperRef
  }, DOMProps, {
    "$disabled": disabled,
    tabIndex: disabled ? -1 : 0,
    onKeyDown: handleOnWrapperKeyDown,
    onClick: handleOnWrapperClick
  }, {
    children: [!showPopover ? (0, _jsxRuntime.jsxs)(Styled.ElementsWrapper, {
      children: [(0, _jsxRuntime.jsx)(Styled.SearchIcon, {}), selectedTags, (0, _jsxRuntime.jsx)(Styled.ArrowIcon, {})]
    }) : null, (0, _jsxRuntime.jsxs)(Styled.Popover, __assign({
      forceDirection: true,
      withFocusTrap: true,
      show: showPopover,
      anchor: wrapperRef,
      style: {
        width: (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width
      },
      offset: {
        y: -40
      },
      tabIndex: disabled ? -1 : 0,
      onClickOutside: function onClickOutside() {
        return setShowPopover(false);
      }
    }, {
      children: [(0, _jsxRuntime.jsxs)(Styled.InputGroup, {
        children: [(0, _jsxRuntime.jsx)(_Icon.default, {
          icon: _Icon.Icons.MagnifyingGlass
        }), (0, _jsxRuntime.jsx)(Styled.Input, {
          ref: setInputRef,
          value: inputValue,
          enterKeyHint: 'enter',
          onKeyDown: handleOnInputKeyDown,
          onValueChange: handleOnInputValueChange
        }), (0, _jsxRuntime.jsx)(_Icon.default, {
          icon: _Icon.Icons.ChevronUp,
          onClick: togglePopover
        })]
      }), selectedTags, withList ? !showListOnInput || inputValue ? (0, _jsxRuntime.jsx)(Styled.ListWrapper, {
        children: (0, _jsxRuntime.jsx)(_List.default, __assign({
          ref: listRef,
          type: _ListItem.ListItemTypes.Select,
          onSelect: handleOnSelect
        }, {
          children: hasTags ? tags.filter(function (tag) {
            if (!showListOnInput || inputValue) {
              return tag.label.toLowerCase().includes(inputValue.toLowerCase());
            } else {
              return true;
            }
          }).map(function (tag) {
            if (!filterNewTagsFromList || !tag.isNew) {
              return (0, _jsxRuntime.jsx)(_ListItem.default, {
                text: tag.label,
                value: tag,
                selected: tag.selected
              }, tag.id);
            } else {
              return null;
            }
          }) : null
        }))
      }) : null : null]
    }))]
  }));
});
TagsInput.displayName = 'TagsInput';
var _default = TagsInput;
exports.default = _default;